<template>
  <div class="session-modal d-flex justify-center align-center">
    <div class="session-box">
      <div class="page-title">
        <span v-if="!noMoreTime">This booking is almost yours!</span>
        <span v-else>Session Timeout!</span>
      </div>

      <div class="session-msg" v-if="!noMoreTime">
        You're so close to securing this booking. Go ahead and complete the last few details to make it yours
        <div v-if="false">
          Your session will expire in <b id="timeLeft"><i class="fas fa-spinner fa-spin"></i></b>.
          <br/>
          Do you need more time?
        </div>
      </div>

      <div class="op-btn btn-md btn-block btn-success" @click="initRenewSession" v-if="!noMoreTime">
        <span>Continue Booking</span>
      </div>
      <div class="op-btn btn-md btn-block btn-secondary" @click="sendMeBack">
        <span v-if="!noMoreTime">NO, Bring me to home page</span>
        <span v-else>Close</span>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
// import moment from 'moment-timezone'
import xcurrency from '@/modules/api/currency'
import trackError from '@/modules/api/track-error'
import booking from '@/modules/api/booking'

export default {
  name: 'session-modal',
  data () {
    return {
      loading: false,
      countDownDelay: '',
      sessionQueue: [],
      flightData: {
        leg1: {},
        leg2: {}
      },
      noMoreTime: false
    }
  },
  computed: {
    store () { return this.$store.state },
    booking () { return this.store.booking },
    locations () { return this.booking.locations },
    filters () { return this.booking.filters },
    isReturning () { return this.filters.departure.isReturning },
    settings () { return this.booking.settings },
    sessionStore () { return this.store.global.sessionModal },
    show: {
      get () { return this.sessionStore.show },
      set (x) {
        this.$store.commit('global/setSessionModalData', {show: x})
      }
    },
    other () { return this.store.other },
    currency () { return this.other.currency },
    apiType () { return this.booking.apiType }
  },
  methods: {
    sendMeBack () {
      this.show = false
      if (this.countDownDelay) clearInterval(this.countDownDelay)
      this.$router.push('search')
      this.noMoreTime = false
    },
    beginCountDown () {
      let self = this
      self.noMoreTime = false
      let timeLeft = this.settings.sessionShowWarning - 1
      if (self.countDownDelay) clearInterval(self.countDownDelay)
      self.countDownDelay = setInterval(function () {
        if (!timeLeft) {
          clearInterval(self.countDownDelay)
          self.noMoreTime = true
          return
        }
        let mins = timeLeft >= 60 ? Math.floor(timeLeft / 60) : 0
        let secs = timeLeft % 60
        let text = `${self.leadingZero(mins)}:${self.leadingZero(secs)} mins`
        if (!mins) text = `${self.leadingZero(secs)} ${secs === 1 ? 'sec' : 'secs'}`

        let textLabel = document.querySelector('#timeLeft')
        if (textLabel) textLabel.innerHTML = text
        timeLeft--
      }, 1000)
    },
    leadingZero (x) {
      x = x + ''
      return x.length === 1 ? '0' + x : x
    },
    initRenewSession () {
      this.sessionQueue = []
      this.flightData = {}
      let lastSelectedFlight = this.booking.lastSelectedFlight

      this.sessionQueue.push(['flight', lastSelectedFlight.leg1.cabin, 'leg1'])
      if (this.isReturning) this.sessionQueue.push(['flight', lastSelectedFlight.leg2.cabin, 'leg2'])

      this.sessionQueue.push(['flightPrice', lastSelectedFlight.leg1.cabin, 'leg1'])
      if (this.isReturning) this.sessionQueue.push(['flightPrice', lastSelectedFlight.leg2.cabin, 'leg2'])

      this.show = false
      this.$store.commit('other/setOtherData', {
        appLoader: true,
        appLoaderMsg: 'Renewing Session...'
      })

      let self = this
      setTimeout(function () {
        self.processRenewSession()
      }, 2000)
    },
    processRenewSession () {
      if (!this.sessionQueue.length) {
        this.show = false
        this.noMoreTime = false
        if (this.countDownDelay) clearInterval(this.countDownDelay)
        this.$store.commit('other/setOtherData', {
          appLoader: false,
          appLoaderMsg: ''
        })
        this.$store.commit('global/setAlertData', {
          show: true,
          message: 'Session Extended!'
        })
        return
      }
      if (this.sessionQueue[0][0] === 'flight') {
        this.getFlightList()
        return
      }
      if (this.sessionQueue[0][0] === 'flightPrice') {
        this.getFlightPrice()
        return
      }
    },
    getFlightList () {
      let self = this
      let cabin = this.apiType === 'API2' ? this.booking.cabinList : this.sessionQueue[0][1]
      let tmpCabin = (typeof cabin === 'object') ? 'API2' : cabin
      let leg = this.sessionQueue[0][2]
      let params = booking.flightParam(self, cabin, leg)

      let locations = self.locations
      if (self.other.widgetTab === 'flight') locations = locations.flight

      self.$store.commit('other/setOtherData', {appLoaderMsg: 'Rechecking Flight...'})
      self.$sdk.post2(`${CONFIG.d2dAPI}/flight`, params, r => {
        try {
          if (r === null || !Object.keys(r).length || ['ERR_BAD_RESPONSE', 'ETIMEDOUT'].indexOf(r.code) > -1 || r.error === 'No flight data found in the response.') {
            trackError.track(self, {
              type: 'flight_booking',
              data: {
                main_pickup: locations.pickup,
                main_dropoff: locations.dropoff,
                request: {
                  url: `${CONFIG.d2dAPI}/flight`,
                  payload: params
                },
                response: r
              }
            })
            self.renewSessionFailed()
            return
          }

          let tmpStoredData = {leg: leg, fields: {}}
          tmpStoredData.fields[tmpCabin] = r
          self.$store.commit('global/setStoredFlightData', tmpStoredData)

          if (r.FlightDataList && r.FlightDataList.JourneyList && r.FlightDataList.JourneyList[0]) {
            let flightData = booking.buildFlightData(self, r, cabin, leg)

            // Save Flight List
            if (self.apiType === 'API1') {
              let tmpAirlineLegData = {leg: leg, fields: {}}
              tmpAirlineLegData.fields[tmpCabin] = flightData.flights
              self.$store.commit('booking/setAirlinesLegData', tmpAirlineLegData)
            } else if (Object.keys(flightData.cabinFlights).length) {
              for (var key in flightData.cabinFlights) {
                let tmpAirlineLegData = {leg: leg, fields: {}}
                tmpAirlineLegData.fields[key] = flightData.cabinFlights[key]
                self.$store.commit('booking/setAirlinesLegData', tmpAirlineLegData)
              }

              let tmpUniqueFlight = {leg: leg, fields: {API2: []}}
              for (var key2 in flightData.uniqueFlights) {
                tmpUniqueFlight.fields.API2.push(flightData.uniqueFlights[key2])
              }
              tmpUniqueFlight.fields.API2Raw = flightData.flights
              self.$store.commit('booking/setAirlinesLegData', tmpUniqueFlight)
            }

            // Save Airline Unique
            let tmpAirlineUnique = {}
            tmpAirlineUnique[tmpCabin] = flightData.airlinesUnique
            self.$store.commit('booking/setAirlinesUniqueLegData', {
              leg: leg,
              fields: tmpAirlineUnique
            })

            self.sessionQueue.shift()
            self.processRenewSession()
          }
        } catch (error) {
          trackError.track(self, {
            type: 'flight_booking',
            data: {
              main_pickup: locations.pickup,
              main_dropoff: locations.dropoff,
              request: {
                url: `${CONFIG.d2dAPI}/flight`,
                payload: params
              },
              response: '',
              console_error: error
            }
          })
          self.renewSessionFailed()
        }
      })
    },
    reconvertCurrency (x, code) {
      let currRate = this.currency.list[code]
      x = parseFloat(x.toFixed(2))
      x = parseFloat((x / currRate).toFixed(2))
      return x
    },
    applyCurrency (x, useSymbol = true) {
      x = parseFloat(x)
      x = x * this.currency.value
      if (!useSymbol) {
        return parseFloat(x.toFixed(2))
      }
      return xcurrency.format({
        code: this.currency.code,
        val: x.toFixed(2)
      }, useSymbol)
    },
    getFlightPrice () {
      let self = this
      let cabin = this.apiType === 'API2' ? this.booking.cabinList : this.sessionQueue[0][1]
      let tmpCabin = (typeof cabin === 'object') ? 'API2' : cabin
      let leg = this.sessionQueue[0][2]

      let lastSelectedFlight = self.booking.lastSelectedFlight[leg]
      let service = ''
      service = self.booking.airlines[leg][`${tmpCabin}Raw`].find(x => {
        return x.flight[0].flightNo === lastSelectedFlight.flightNo &&
          x.flight[0].airline.code === lastSelectedFlight.airlineCode &&
          x.flight[0].origin.DateTime === lastSelectedFlight.date &&
          x.flight[x.flight.length - 1].destination.DateTime === lastSelectedFlight.arriveDate
      })

      let locations = self.locations
      if (self.other.widgetTab === 'flight') locations = locations.flight

      self.$store.commit('other/setOtherData', {
        appLoader: true,
        appLoaderMsg: 'Verifying flight...'
      })
      self.$sdk.post2(`${CONFIG.d2dAPI}/flight/flight-price`, {ResultToken: service.token}, r => {
        try {
          if (!r.Status) {
            trackError.track(self, {
              type: 'flight_price',
              data: {
                main_pickup: locations.pickup,
                main_dropoff: locations.dropoff,
                request: {
                  url: `${CONFIG.d2dAPI}/flight/flight-price`,
                  payload: {ResultToken: service.token}
                },
                response: r
              }
            })
            self.renewSessionFailed()
            return
          }

          let resToken = r.UpdateFareQuote.FareQuoteDetails.JourneyList.ResultToken
          let tmpFinalPrice = {}
          let tmpLastToken = {}
          tmpFinalPrice[leg] = r
          tmpLastToken[leg] = resToken
          self.$store.commit('booking/setFinalPrice', tmpFinalPrice)
          self.$store.commit('booking/setLastToken', tmpLastToken)

          self.sessionQueue.shift()
          self.processRenewSession()
        } catch (error) {
          trackError.track(self, {
            type: 'flight_price',
            data: {
              main_pickup: locations.pickup,
              main_dropoff: locations.dropoff,
              request: {
                url: `${CONFIG.d2dAPI}/flight/flight-price`,
                payload: {ResultToken: service.token}
              },
              response: '',
              console_error: error
            }
          })
          self.renewSessionFailed()
        }
      })
    },
    renewSessionFailed () {
      this.$store.commit('other/setOtherData', {
        appLoader: false,
        appLoaderMsg: ''
      })
      this.$store.commit('global/setAlertData', {
        show: true,
        message: 'Something went wrong. Renew session failed.'
      })

      this.sessionQueue = []
      this.flightData = {}
      this.sendMeBack()
    }
  },
  mounted () {
    this.beginCountDown()
  }
}
</script>

<style lang="scss" scoped>
.session-modal{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0,0,0, .3);
  z-index: 2;
}
.session-box{
  background: #f9f9f9;
  border-radius: 4px;
  box-shadow: 2px 2px 4px rgba(0,0,0, .3);
  padding: 20px;
  width: 100%;
  max-width: 400px;
}

.page-title{
  font-size: 21px;
  font-weight: 600;
  padding: 0 0 15px;
  text-align: center;
}
.session-msg{
  letter-spacing: .6px;
  margin: 0 0 40px
}
.op-btn{
  margin: 0 0 10px;
}
.btn-secondary:hover{
  color: #333!important;
}
</style>



// WEBPACK FOOTER //
// SessionModal.vue?14f7da50